<template>
  <div>
    <Modal
      v-model="agreementModal"
      :title="PROCESS_ENV.NODE_PLA === 'wg' ? '盛骁科技用户协议' : '商标及专利服务用户协议'"
      @on-visible-change="close"
      class="agreement-modal"
      footer-hide
      :closable="false"
      :mask-closable="false"
    >
    <UserAgreement></UserAgreement>
      <div style="text-align:center;padding-bottom:30px;">
        <Button @click="close" type="primary">知道了</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import UserAgreement from '@/views/common/userAgreement'
export default {
  data() {
    return {
      agreementModal: true,
    };
  },
  components:{
    UserAgreement
  },
  methods: {
    close(val) {
      this.$emit('changeState', val);
    },
  },
};
</script>
<style lang="less" scoped>
.agreement-modal /deep/ .ivu-modal-content {
  height: 500px;
  overflow-y: scroll;
  .content-box {
    p {
      line-height: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// xcloud-client-components-web/sureOrder/components/userAgreement.vue